import { mdiWrench } from '@mdi/js';
import React from 'react';

/** Browser window with a wrench, in the Azimut blues: the maintenance page illustration. */
export const MaintenanceIllustration = () => (
  <svg className='maintenance-illustration' viewBox='0 0 280 200' role='img' aria-hidden='true' focusable='false'>
    <ellipse cx='140' cy='104' rx='112' ry='78' fill='#F3F6FF' />
    <ellipse cx='176' cy='70' rx='58' ry='44' fill='#EBF0FF' />
    <circle cx='212' cy='42' r='14' fill='#EBF0FF' />
    <circle cx='34' cy='90' r='9' fill='#7FA6EC' />
    <circle cx='254' cy='90' r='9' fill='#F5A33C' />
    <rect x='72' y='52' width='136' height='108' rx='8' fill='#FFFFFF' stroke='#5B8DE0' strokeWidth='4' />
    <path d='M72 60a8 8 0 0 1 8-8h120a8 8 0 0 1 8 8v14H72z' fill='#5B8DE0' />
    <circle cx='86' cy='63' r='3.5' fill='#FFFFFF' />
    <circle cx='98' cy='63' r='3.5' fill='#FFFFFF' />
    <circle cx='110' cy='63' r='3.5' fill='#FFFFFF' />
    <rect x='60' y='158' width='160' height='4' rx='2' fill='#D8DAE5' />
    <circle cx='118' cy='128' r='14' fill='#BFD2F5' />
    <path d={mdiWrench} fill='#2E6CD1' transform='translate(196 80) scale(3.6) rotate(90)' />
  </svg>
);
